import React, { memo } from 'react';
import { Box, Skeleton } from '@mui/material';
import { COLOR } from '@src/styles/color';
import {
  TextLinesSkeleton,
  ConfigToolbarSkeleton,
} from '../../Presentation/Content/ExtractSkeleton';

const ExtractSkeletonRow = memo(({ style }) => (
  <Box style={style} sx={{ padding: '24px', boxSizing: 'border-box' }}>
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        width: '100%',
        padding: '16px',
        borderRadius: '12px',
        backgroundColor: COLOR.white,
        boxSizing: 'border-box',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <ConfigToolbarSkeleton />
        <Skeleton variant="circular" animation="wave" width={24} height={24} />
      </Box>
      <TextLinesSkeleton />
    </Box>
  </Box>
));

export default ExtractSkeletonRow;
